import React, { useState } from 'react';
import Payimg from '../../images/pay.svg';
// import { useState } from "react";
const isTwelveChars = (value) => value.trim().length === 12;
let neftReferenceValidity = true;

function PaymentInfo({ formData, setFormData }) {
  const [paymentScreenshotFilename, setPaymentScreenshotFilename] =
    useState('');
  const [documentFilenames, setDocumentFilenames] = useState([]);

  return (
    <div>
      <div className="document-container">
        <p className="data">Payment Date</p>
        <input
          type="date"
          required
          value={formData.queryDate}
          onChange={(e) => {
            setFormData({ ...formData, queryDate: e.target.value });
          }}
        />

        <p className="data">NEFT Reference No./ Transaction Id</p>
        <input
          type="text"
          value={formData.NEFT}
          onChange={(e) => {
            setFormData({ ...formData, NEFT: e.target.value });
            // if (isTwelveChars(e.target.value)) {
            //   neftReferenceValidity = true;
            // } else if (e.target.value.length === 0) {
            //   neftReferenceValidity = true;
            // }
            // else if (!isTwelveChars(e.target.value)) {
            //   neftReferenceValidity = false;
            // }
          }}
        />
        {!neftReferenceValidity && (
          <p className="invalid">
            Please enter NEFT Reference number of 12 digits
          </p>
        )}

        <div className="document-upload-container payementSS">
          <p className="data">Attach the payment acknowlegment </p>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {paymentScreenshotFilename}
          </span>{' '}
          <input
            type="file"
            id="inputPayment"
            accept="application/pdf, images/png, images/jpg"
            onChange={(event) =>
              setPaymentScreenshotFilename(event.target.files[0].name)
            }
          />
          <label htmlFor="inputPayment" className="payement-image-btn" value="">
            Upload
          </label>
        </div>

        <div className="document-upload-container">
          <p className="data">
            Attach all documents to be verified:
            <br />
            <span style={{ fontSize: 12 }}>
              (Note: Documents must be in PDF format)
            </span>
            {formData.Documents && (
              <ol style={{ marginTop: 20 }}>
                <b style={{ marginLeft: -20 }}>
                  Required Document{formData.Documents.length !== 1 ? 's' : ''}
                </b>
                {formData.Documents.map((docName) => (
                  <li>{docName}</li>
                ))}
              </ol>
            )}
            <br />
            Make sure to select all of the files that you would like to upload.
            <br />
            This can be done by selecting the first file in the file explorer
            tab and then using the "shift" key to select the last one.
            <br /> Alternatively, you can also use the "Ctrl" key to select
            multiple individual files.
            <ol style={{ marginTop: 20 }}>
              <b style={{ marginLeft: -20 }}>
                Uploaded Document{documentFilenames.length !== 1 ? 's' : ''}
              </b>
              {documentFilenames.map((filename, index) => (
                <li key={index}>{filename}</li>
              ))}
            </ol>
          </p>
          <input
            type="file"
            id="inputFiles"
            multiple
            accept="application/pdf"
            onChange={(event) => {
              setDocumentFilenames(
                [...event.target.files].map((file) => file.name)
              );
            }}
          />
          <label htmlFor="inputFiles" className="document-upload-btn">
            {' '}
            Upload
          </label>
        </div>

        <br />
        <br />
        <h5 style={{ margin: 0 }}>Verification Charges</h5>
        <div className="verification-info">
          <div className="charges-details">
            <p>
              Per student charges are Rs. 1000/- and GST 18% i.e. Rs. 180/- i.e
              Total 1180/-
            </p>

            <p>Mode of payment - online </p>

            <p>Payment Details -</p>
            <p>In favor of MIT World peace university</p>
            <p>Bank name : Bank of India</p>
            <p>Branch name : Pune MIT Branch</p>
            <p>Account no. : 053010110013323</p>
            <p>IFCS Code : BKID0000530</p>

            <p>
              Processing Tenure : Maximum 7 working days from date of
              application with all required documents
            </p>
          </div>
          <div className="payimg-container">
            <img src={Payimg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentInfo;
